//@ts-nocheck
import React, { useEffect, useState } from "react";

import { Form, Input, InputNumber, Popconfirm, Table, Typography } from "antd";
import { ColumnGroupType, TableProps } from "antd/es/table";
import { Button, Dropdown, Flex, Layout, Menu, Tabs } from "antd";
import { Header } from "antd/es/layout/layout";
import Title from "antd/es/typography/Title";
import { BsThreeDotsVertical } from "react-icons/bs";
import DeleteOutlined from "@ant-design/icons/lib/icons/DeleteOutlined";
import { EditOutlined } from "@ant-design/icons";
import FormTable from "../../../Components/DynamicTable/FormTable";
import { stat } from "fs";
import { APICall } from "../../../Helpers/APICalls/APICalls";
import MyTableConfig from "../../Home/DynamicTableExampleConfig.json";
import {
    generateReport,
    fetchReportData,
} from "../../../Helpers/APIEndpoints/Endpoints";

interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
    editing: boolean;
    dataIndex: string;
    title: any;
    inputType: "number" | "text";
    record: Item;
    index: number;
    children: React.ReactNode;
}

const EditableCell: React.FC<EditableCellProps> = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
}) => {
    const inputNode = inputType ? ( inputType === "number" ? <InputNumber /> : <Input />) : <Input />;

    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{ margin: 0 }}
                    rules={[
                        {
                            required: true,
                            message: `Please Input ${title}!`,
                        },
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};

// Apply Loaders and Other things // Convert it into Component
//Comments also check validations on filter  on change 
const StateMasterDashboard: React.FC = () => {
    const [form] = Form.useForm();
    const [data, setData] = useState(null);
    const [dataConfig, setDataConfig] = useState(null);
    const [editingKey, setEditingKey] = useState("");
    const [pageSize, setPageSize] = useState(50);
    const [page, setPage] = useState(1);
    const [activeTab, setActiveTab] = useState("Actions");
    const [columns, setColumns] = useState([]);
    const [filters, setFilters] = useState([]);
    const [isTableLoading, setTableLoading] = useState<boolean>(false);
    const [isReset, setIsReset] = useState(false);

    useEffect(() => {
        getReportConfig();
    }, []);

    const getReportConfig = async () => {
        try {
            let reportConfigResponse = await APICall(generateReport, "POST", {
                ReportId: 1
            });
            if (reportConfigResponse?.data != null) {
                getReportData(null, reportConfigResponse?.data?.config?.reportQuery);
                console.log("reportConfigResponse?.data:::::", reportConfigResponse?.data);
                setDataConfig(reportConfigResponse?.data?.config);
                setColumns(reportConfigResponse?.data?.columns);
                setFilters(reportConfigResponse?.data?.filters);
                console.log("reportConfigResponse?.data?.filters:::::::", reportConfigResponse?.data?.filters)
            }
        }
        catch (error) {
            console.error(error);
        }
        finally {
            //
        }
    }

    const getReportData = async (formValue = null, Querry = "") => {
        try {
            let fetchResponse = await APICall(fetchReportData, "POST", {
                // currently Hardcoaded 
                UserId: 6,
                RoleId: 1,
                PageNumber: page,
                PageSize: pageSize,
                sortBy: "Title",
                desc: true,
                FormData: formValue != null ? JSON.stringify(formValue) : null,
                ReportQuery: Querry != "" ? Querry : dataConfig?.reportQuery,
            });

            if (fetchResponse?.data?.length > 0) {
                console.log("fetchResponse::::::::::", fetchResponse);
                setData(fetchResponse?.data);
            }
        }
        catch (error) {
            console.error(error);
        }
        finally {

        }
    }

    const isEditing = (record: Item) => record.key === editingKey;

    const edit = (record: any & { key: React.Key }) => {
        const finobj = columns.reduce((acc, curr) => {
            acc[curr.key] = "";
            return acc;
        }, {});

        console.log("finobj:::::::", finobj);
        form.setFieldsValue(finobj);
        setEditingKey(record.key);
    };

    const cancel = () => {
        setEditingKey("");
    };

    // const save = async (key: React.Key) => {
    //   try {
    //     const row = (await form.validateFields()) as Item;

    //     const newData = [...data];
    //     const index = newData.findIndex((item) => key === item.key);
    //     if (index > -1) {
    //       const item = newData[index];
    //       newData.splice(index, 1, {
    //         ...item,
    //         ...row,
    //       });
    //       setData(newData);
    //       setEditingKey("");
    //     } else {
    //       newData.push(row);
    //       setData(newData);
    //       setEditingKey("");
    //     }
    //   } catch (errInfo) {
    //     console.log("Validate Failed:", errInfo);
    //   }
    // };

    const rowSelection: TableProps<unknown>["rowSelection"] = {
        onChange: (selectedRowKeys: React.Key[], selectedRows: unknown[]) => {
            console.log(
                `selectedRowKeys: ${selectedRowKeys}`,
                "selectedRows: ",
                selectedRows
            );
        },
        getCheckboxProps: (record: unknown) => ({
            disabled: record?.["name"] === "Disabled User", // Column configuration not to be checked
            name: record?.["name"],
        }),
    };

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record: Item) => ({
                record,
                inputType: col.dataIndex === "age" ? "number" : "text",
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });

    //   useEffect(() => {
    //     const newColumns = [...columns];
    //     const actionColumn = newColumns?.find((col) => col.key === "action");
    //     if (actionColumn) {
    //       actionColumn.render = (_: any, record: Item) => {
    //         const editable = isEditing(record);
    //         return editable ? (
    //           <span>
    //             <Typography.Link
    //               onClick={() => save(record.key)}
    //               style={{ marginRight: 8 }}
    //             >
    //               Save
    //             </Typography.Link>
    //             <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
    //               <a>Cancel</a>
    //             </Popconfirm>
    //           </span>
    //         ) : (
    //           <Dropdown
    //             overlay={
    //               <Menu>
    //                 <Menu.Item key="edit" onClick={() => edit(record)}>
    //                   <EditOutlined style={{ marginRight: 8 }} />
    //                   Edit
    //                 </Menu.Item>
    //                 <Menu.Item key="delete">
    //                   <Popconfirm
    //                     title="Are you sure you want to delete this record?"
    //                     onConfirm={() => {
    //                       const newData = data.filter(
    //                         (item) => item.key !== record.key
    //                       );
    //                       setData(newData);
    //                     }}
    //                     okText="Yes"
    //                     cancelText="No"
    //                     style={{ marginTop: 0 }}
    //                   >
    //                     <DeleteOutlined
    //                       style={{
    //                         marginRight: 8,
    //                         marginTop: -8,
    //                         padding: 0,
    //                       }}
    //                     />
    //                     Delete
    //                   </Popconfirm>
    //                 </Menu.Item>
    //               </Menu>
    //             }
    //             trigger={["click"]}
    //             placement="leftTop"
    //           >
    //             <Button
    //               icon={<BsThreeDotsVertical />}
    //               style={{
    //                 border: "none",
    //                 background: "transparent",
    //                 fontSize: "18px",
    //               }}
    //             />
    //           </Dropdown>
    //         );
    //       };
    //     }
    //     setColumns(newColumns);
    //   }, []);

    const handleButtonClick = async (form: any, buttonConfig: any) => {
        try {
            if (buttonConfig === "reset") {
                form.resetFields();
                setIsReset(!isReset);
                //clearing rowForm Data:
                getReportData();
                console.log("Form reset successfully.");

                return;
            }

            if (buttonConfig === "apply") {
                //await form.validateFields();
                let formValue = { ...form.getFieldsValue() };
                getReportData(formValue);
            }
        }
        catch (error) {
            console.error(error);
        }
        finally {

        }
    };

    return (
        <div className="Container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="pageName">
                        <Title level={4}>
                            {dataConfig?.name}
                        </Title>

                        <Form form={form} component={false}>
                            <FormTable
                                components={{
                                    body: {
                                        cell: EditableCell,
                                    },
                                }}
                                loading={isTableLoading}
                                filters={filters}
                                rowClassName="editable-row"
                                dataSource={data}
                                isAddRowTable
                                columns={mergedColumns}
                                scroll={{ x: "max-content", y: "calc(100vh - 200px)" }}
                                style={{ paddingBottom: 40 }}
                                rowSelection={{ type: "checkbox", ...rowSelection }}
                                handleButtonClick={handleButtonClick}
                                pagination={{
                                    position: ["bottomRight"],
                                    pageSize: pageSize,
                                    showSizeChanger: true,
                                    pageSizeOptions: [5, 10, 20, 50, 100],
                                    onShowSizeChange: (current, size) => {
                                        console.log("Current: ", current, "Size: ", size);
                                        setPageSize(size);
                                    },
                                }}
                            />
                        </Form>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default StateMasterDashboard;
